const badges = [
  { label: 'HIPAA', detail: 'Health Data' },
  { label: 'NIST', detail: 'Framework' },
  { label: 'PCI', detail: 'Payment Security' },
  { label: 'SOX', detail: 'Financial Compliance' },
  { label: 'GLBA', detail: 'Financial Privacy' },
  { label: 'ISO', detail: 'Standards' },
];

const ComplianceStrip = () => {
  return (
    <section className="py-20 lg:py-24 bg-white border-t border-slate-100 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-center gap-12 xl:gap-20">

          {/* Left */}
          <div className="lg:w-80 flex-shrink-0">
            <div className="inline-flex items-center gap-2 border border-teal-200 bg-teal-50 rounded-full px-3.5 py-1.5 mb-6">
              <i className="ri-award-fill text-teal-600 text-xs" />
              <span className="text-teal-700 text-xs font-bold tracking-widest uppercase">Regulatory Compliance</span>
            </div>
            <h2 className="text-2xl lg:text-3xl font-extrabold text-slate-900 leading-tight mb-4">
              Compliance-Aware IT Infrastructure
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed">
              Built to support businesses in regulated and high-security environments. We know the standards — so you don't have to.
            </p>
          </div>

          {/* Right: badges */}
          <div className="flex-1">
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
              {badges.map((badge, i) => (
                <div
                  key={i}
                  className="group flex flex-col items-center justify-center gap-1.5 bg-slate-50 border border-slate-200 hover:border-teal-300 hover:bg-teal-50 rounded-xl py-5 px-3 transition-all duration-200 cursor-default"
                >
                  <span className="text-slate-900 font-extrabold text-base tracking-tight group-hover:text-teal-700 transition-colors">
                    {badge.label}
                  </span>
                  <span className="text-slate-400 text-[10px] text-center leading-tight group-hover:text-teal-600 transition-colors">
                    {badge.detail}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceStrip;
